var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-main"},[_c('basic-info-item',{attrs:{"msg":_vm.allData}}),_c('number-portrait-item',{attrs:{"msg":_vm.infoData}}),_c('visit-situation-item',{attrs:{"companyType":_vm.infoData.dictionary_type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }